import styled from 'styled-components'
import {
	PRIMARY_LIGHT,
	MEDIUMGRAY,
	SOFTYELLOW,
	SOFTBLUE,
	SOFTGRAY,
	DARKBLUE,
	PRIMARY_COLOR,
	WHITE,
	GRAY,
	BLUE,
	RED,
} from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants'

export const PointsCointainer = styled.div`
	padding: 40px 0;
	display: flex;
	justify-content: space-around;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: center;
		align-items: flex-start;
	}
`

export const Points = styled.div`
	color: ${GRAY};
	font: 600 2rem 'Source Sans Pro';
	width: calc(400% / 12 - 0.8rem);
	margin: 0 0.8rem;
	text-align: center;

	&.equal {
		width: 10%;
		color: ${SOFTBLUE};
		font-weight: 600;
		font-size: 3rem;
		line-height: 21px;
		display: flex;
		justify-content: center;
		align-items: unset;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			line-height: 26px;
			font-size: 5rem;
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: calc(200% / 12 - 0.8rem);
	}
`

export const BoxTransferPoints = styled.section`
	.kAZauy {
		.title {
			font-size: 2.8rem;
			font-weight: 600;
			text-align: center;
			color: ${BLUE};
		}
		.modal-content {
			p {
				&:first-child {
					font-size: 1.8rem;
				}
			}
			ul {
				list-style: none;
				padding: 0;

				li {
					line-height: 30px;
				}
			}
		}
	}

	.hazYdI {
		justify-content: space-around;

		button {
			color: ${WHITE};
			text-decoration: none;
			width: 100%;
			margin-bottom: 10px;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				width: 15rem;
				margin: 0;
			}

			&:first-child {
				order: 2;
			}
			&:last-child {
				background: linear-gradient(
					180deg,
					${DARKBLUE} 0%,
					${BLUE} 193.64%
				);
			}
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const TitleTransferPoints = styled.h2`
	border-bottom: 1px solid ${SOFTGRAY};
	padding-bottom: 10px;
	margin-bottom: 20px;
	color: ${PRIMARY_COLOR};
	font: 400 2rem/28px 'Source Sans Pro';
	text-align: center;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		text-align: left;
		font-size: 3.2rem;
		padding-bottom: 30px;
		margin-bottom: 30px;
	}
`

export const ContainerPoints = styled.section`
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
`

export const Column = styled.div`
	display: flex;
	flex-wrap: wrap;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		justify-content: space-between;
	}

	&.transfer-field {
		align-self: center;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			align-self: flex-end;
			padding-top: 40px;
		}
	}

	button {
		background: linear-gradient(
			180deg,
			${PRIMARY_LIGHT} 0%,
			${SOFTYELLOW} 193.64%
		);
		border-radius: 5px;
		font: bold 1.8rem/24px 'Source Sans Pro';
		width: 140px;
		height: 45px;
		color: ${WHITE};
		border: 0;
		cursor: pointer;

		&.disabled {
			opacity: 0.5;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 228px;
			height: 64px;
		}
	}
`

export const Item = styled.div`
    width: 100%;
    text-align: center;
    word-break: break-all;
    margin-bottom: 20px;

    &.balance {
        @media screen and (min-width: ${breakpoints.MOBILE}px) {
            width: 20%;
        }
    }

    &.only {
		display: flex;
		justify-content: center;
		align-itens: center;



		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			justify-content: flex-end;
		}
    }

    h5 {
        color: ${GRAY};
        font: 16px/20px 'Source Sans Pro';

        &.center {
			text-align: center;
			word-break: normal;
        }
    }

    em {
        color: ${MEDIUMGRAY}
        font-size: 26px
        line-height: 45px;
    }

    small {
        font-size: 16px
        color: ${GRAY}
    }

    em, small {
        font-style: normal;
        text-align: center;
        display: block;
    }

    .select {
        width: 90%;
        margin: 20px auto 0;
    }

    @media screen and (min-width: ${breakpoints.MOBILE}px) {
        width: 25%;
        text-align: left;
        margin: 0;

        em {
            font-size: 36px;
        }

        .select {
            width: 100%;
            margin: 0;
        }
    }
`

export const Regulation = styled.footer`
	padding: 10px 0;
`

export const ImportantRules = styled.h4`
	color: ${BLUE};
	font-size: 1.8rem;
	font-weight: 100;
	padding-bottom: 10px;
	margin: 0;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		padding-bottom: 20px;
	}
`

export const RulesList = styled.ul`
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		padding-left: 15px;
	}
`
export const RulesListItem = styled.li`
	color: ${GRAY};
	font-size: 1.5rem;
	line-height: 30px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const Insuficient = styled.small`
	padding: 20px 0;
	display: block;
	color: ${RED} !important;
`
